export const environment = {
    production: false,
    logLevel: 'DEBUG',
    settings:
    {
        authUrl: "https://portalserver-uat.acimobills.com/auth/api",
        portalUrl: "https://portalserver-uat.acimobills.com/portal/api",
        regions: [
            {"region": "uat", "baseUrl": "https://uat.walletron.click/Walletron/api"}
        ]
    }
};